import { render, staticRenderFns } from "./CommonIconBtn.vue?vue&type=template&id=4210cc25&scoped=true&"
import script from "./CommonIconBtn.vue?vue&type=script&lang=ts&"
export * from "./CommonIconBtn.vue?vue&type=script&lang=ts&"
import style0 from "./CommonIconBtn.vue?vue&type=style&index=0&id=4210cc25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4210cc25",
  null
  
)

export default component.exports